<template>
    <div class="w-full md:w-1/2 xl:w-1/4 p-4">
      <div class="bg-white shadow-lg rounded-lg border-t-4 border-gray-600 p-6">
        <div class="border-b border-gray-300 pb-4">
          <h1 class="text-2xl font-semibold text-gray-800">Create Feed</h1>
        </div>
        <form class="space-y-4 mt-4">
          <div>
            <label class="block font-semibold text-gray-700 mb-1">Title</label>
            <input type="text" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-gray-600 focus:outline-none" />
          </div>
          <div>
            <label for="subjects" class="block font-semibold text-gray-700 mb-1">Select subjects</label>
            <select id="subjects" name="subjects" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-gray-600 focus:outline-none">
              <option value="">Select subject</option>
              <option value="math">Math</option>
              <option value="science">Science</option>
              <option value="history">History</option>
            </select>
          </div>
          <div>
            <label for="class" class="block font-semibold text-gray-700 mb-1">Select class</label>
            <select id="class" name="class" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-gray-600 focus:outline-none">
              <option value="">Select class</option>
              <option value="JS1">JS1</option>
              <option value="JS2">JS2</option>
              <option value="JS3">JS3</option>
            </select>
          </div>
          <div>
            <label class="block font-semibold text-gray-700 mb-1">Comment</label>
            <textarea rows="3" class="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-gray-600 focus:outline-none"></textarea>
          </div>
          <div>
            <label class="block font-semibold text-gray-700 mb-1">Upload file</label>
            <input type="file" class="block w-full text-lg border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none" />
          </div>
          <button type="submit" class="w-full py-2 px-4 bg-gray-700 hover:bg-gray-500 text-white font-semibold rounded-lg transition ease-in duration-200">
            Post Feed
          </button>
        </form>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
  
const isAccordionOpen = ref(false);
  
const toggleAccordion = () => {
  isAccordionOpen.value = !isAccordionOpen.value;
};
</script>
  
  <style scoped>
  /* Add any scoped styles if needed */
  </style>
  
